import React, { createContext, useState, useEffect, useRef } from "react";
import { io } from "socket.io-client";

const SOCKET_URL = "https://api.beepplatform.com";

export const NotificationAlertContext = createContext();

export function NotificationAlertProvider({ children }) {
  const [notificationAlert, setNotificationAlert] = useState(false);
  const [newNotification, setNewNotification] = useState(null);
  const socketRef = useRef(null);

  useEffect(() => {
    // Create socket connection once when provider mounts
    socketRef.current = io(SOCKET_URL, {
      path: "/socket.io",
      transports: ["websocket"],
    });

    socketRef.current.on("connect", () => {
      console.log("Notification socket connected");
    });

    socketRef.current.on("newAdminNotification", (notification) => {
      setNewNotification(notification);
      setNotificationAlert(true);
    });

    socketRef.current.on("disconnect", () => {
      console.log("Notification socket disconnected");
    });

    // Cleanup on unmount
    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
      }
    };
  }, []);

  return (
    <NotificationAlertContext.Provider
      value={{
        notificationAlert,
        setNotificationAlert,
        newNotification,
        setNewNotification,
      }}
    >
      {children}
    </NotificationAlertContext.Provider>
  );
} 